export default __webpack_public_path__ + "assets/aa49e3ddf20dcb1cb9df13b875564ded.woff2";